"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateIn = void 0;
class TemplateIn {
    constructor() {
    }
    static getAttributeTypeMap() {
        return TemplateIn.attributeTypeMap;
    }
}
exports.TemplateIn = TemplateIn;
TemplateIn.discriminator = undefined;
TemplateIn.attributeTypeMap = [
    {
        "name": "description",
        "baseName": "description",
        "type": "string",
        "format": ""
    },
    {
        "name": "featureFlag",
        "baseName": "featureFlag",
        "type": "string",
        "format": ""
    },
    {
        "name": "filterTypes",
        "baseName": "filterTypes",
        "type": "Array<string>",
        "format": ""
    },
    {
        "name": "instructions",
        "baseName": "instructions",
        "type": "string",
        "format": ""
    },
    {
        "name": "instructionsLink",
        "baseName": "instructionsLink",
        "type": "URI",
        "format": "uri"
    },
    {
        "name": "kind",
        "baseName": "kind",
        "type": "TransformationTemplateKind",
        "format": ""
    },
    {
        "name": "logo",
        "baseName": "logo",
        "type": "URI",
        "format": "uri"
    },
    {
        "name": "name",
        "baseName": "name",
        "type": "string",
        "format": ""
    },
    {
        "name": "transformation",
        "baseName": "transformation",
        "type": "string",
        "format": ""
    }
];
//# sourceMappingURL=TemplateIn.js.map